<template>
  <section class="invoice-preview-wrapper mt-2">
    <b-modal
      id="modal-prevent-closing"
      ref="modalMatricula"
      :click-to-close="false"
      title="Buscar alumno por matricula"
      ok-title="Buscar"
      cancel-variant="outline-secondary"
      @ok="handleOk"
    >
      <p><b>1) Seleccione al alumno:</b></p>

      <selectmatricula
        @matricula="matriculan=$event"
      />
    </b-modal>
    <b-modal
      id="modal-prevent-closing"
      ref="modalEspecialidad"
      :click-to-close="false"
      title="Selccione la especialidad del alumno"
      ok-title="Buscar"
      cancel-variant="outline-secondary"
      @ok="handlespecialidadOk"
    >
      <v-select
        id="inscrito"
        v-model="Especialidadn"
        placeholder="Seleccione una especialidad"
        label="nombre"
        :options="especialidades"
        :clearable="false"
      />

    </b-modal>
    <b-row class="invoice-preview">

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="info"
            class="mb-75"
            block
            @click="openmodal()"
          >
            Buscar otro alumno
          </b-button>
          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Note -->
          <b-card-body
            class="invoice-padding pt-0 text-center"
          >
            <span class="font-weight-bold">Nota:</span>
          </b-card-body>
          <!-- like footer -->
          <template #footer>
            <em>Al terminar puede cerrar esta ventana</em>
          </template>

        </b-card>
      </b-col>

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper m-0">
                  <logo />
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- lo que se imprime -->
          <b-overlay
            :show="showLoader"
            rounded="sm"
          >
            <b-table-lite
              responsive
              :items="infokardex"
              :fields="columnsCC"
              :busy="showLoader"
              show-empty
              empty-text="No se encontraron resultados"
            >
              <!-- Head -->
              <template #thead-top>
                <b-tr>
                  <b-th
                    colspan="12"
                  >
                    Posgrado: <code v-if="Especialidadn != null">{{ Especialidadn.nombre }}</code>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th
                    colspan="12"
                  >
                    Nombre:  <code v-if="detallesAlumno != null">{{ detallesAlumno.nombre }} {{ detallesAlumno.segundoNombre }} {{ detallesAlumno.apellidoPaterno }} {{ detallesAlumno.apellidoMaterno }}</code>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th colspan="12">
                    Matricula: <code v-if="detallesAlumno!= null "> {{ detallesAlumno.matricula }}</code>
                  </b-th>
                </b-tr>
              </template>
            </b-table-lite>
            <!-- Spacer -->
            <hr class="invoice-spacing">
            <b-card-body class="invoice-padding pt-0 text-center">
              <b-row class="m-0">
                <b-col>
                  <b-row class="text-black-50">
                    <b-col
                      md="12"
                      class="text-center m-2"
                    >
                      <h6>
                        Campus Virtual
                      </h6>
                      <h6>
                        Instituto para el Desarrollo Técnico de las Haciendas Públicas
                      </h6>
                    </b-col>
                  </b-row>
                  <b-row class="mb-0 text-center">
                    <b-col>
                      <p>
                        <span class="d-block d-md-inline-block mt-25">
                          Derechos Reservados © INDETEC  {{ new Date().getFullYear() }}
                        </span>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-overlay>
        </b-card>
      </b-col>

    </b-row>
  </section>
</template>

<script>
/* eslint-disable global-require */
import {
  ref, onMounted,
} from '@vue/composition-api'
// import router from '@/router'
import {
  BModal, BRow, BCol, BCard, BCardBody,
  BTableLite, BButton, VBToggle, BTr, BTh,
  BOverlay, VBModal,
} from 'bootstrap-vue'
import { isEmptyObject } from '@core/utils/utils'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { timestampToDate } from '@core/utils/filter'
import { required } from '@validations'
import selectmatricula from '@/views/components/selects/select-matricula.vue'

import vSelect from 'vue-select'
import {
  reportImpresoKardex,
  cabeceraAlumno,
  especialidadAlumno,
} from './useReportes'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BButton,
    BTr,
    BTh,
    Logo,
    BOverlay,
    BModal,
    selectmatricula,
  },
  setup(_, { root }) {
    const detallesAlumno = ref({})
    const showLoader = ref(false)
    const toast = useToast()
    // catch values
    const matriculan = ref(null)
    const Especialidadn = ref(null)
    const modalMatricula = ref()
    const modalEspecialidad = ref()
    const infokardex = ref([])
    const especialidades = ref([])
    const columnsCC = [
      {
        key: 'orden',
        label: 'Nivel',
        sortable: true,
      },
      {
        key: 'clave_materia',
        label: 'Clave',
        sortable: true,
      },
      { key: 'nombre_materia', label: 'Materia' },
      { key: 'periodoClave', label: 'Periodo' },
      {
        key: 'cal_fin', label: 'Calificación',
      },
      {
        key: 'descripcion', label: 'Estado',
      },
    ]

    // detalle del curso
    const CabeceraReport = matricula => {
      showLoader.value = true
      cabeceraAlumno(matricula).then(response => {
        // eslint-disable-next-line prefer-destructuring
        detallesAlumno.value = response.data[0]
        showLoader.value = false
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [Información Curso]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }

    // get api participantes.js
    const loadAlumnos = (matricula, especialidad) => {
      showLoader.value = true
      reportImpresoKardex(matricula, especialidad).then(response => {
        infokardex.value = response.data
        showLoader.value = false
        CabeceraReport(matricula)
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [alumnos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }
    const handlespecialidadOk = bvModalEvt => {
      bvModalEvt.preventDefault()
      root.$nextTick(() => {
        loadAlumnos(matriculan.value.matricula, Especialidadn.value.especialidad)
        modalEspecialidad.value.hide()
      })
    }
    const handleOk = bvModalEvt => {
      bvModalEvt.preventDefault()

      infokardex.value = null
      detallesAlumno.value = null
      Especialidadn.value = null
      showLoader.value = true
      especialidadAlumno(matriculan.value.matricula).then(response => {
        if (response.data.length !== 0) {
          especialidades.value = response.data
          if (response.data.length === 1) {
            // eslint-disable-next-line prefer-destructuring
            Especialidadn.value = response.data[0]
            loadAlumnos(matriculan.value.matricula, Especialidadn.value.especialidad)
          } else {
            modalEspecialidad.value.show()
          }
        }
        root.$nextTick(() => {
          modalMatricula.value.hide()
        })
      }, errork => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [kardex]',
            text: errork,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        }, { timeout: 9000 })
      })
    }
    const printInvoice = () => {
      window.print()
    }
    const openmodal = () => {
      modalMatricula.value.show()
    }

    onMounted(
      () => {
        openmodal()
      },
    )

    return {
      // data
      infokardex,
      detallesAlumno,
      columnsCC,
      required,
      // functions
      printInvoice,
      loadAlumnos,
      // flags
      showLoader,
      // tools
      isEmptyObject,
      // date
      timestampToDate,
      matriculan,
      Especialidadn,
      openmodal,
      handleOk,
      handlespecialidadOk,
      modalMatricula,
      modalEspecialidad,
      especialidades,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
   html, body {
        height: 98%;
    }
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: .3rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }
  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  .buy-now > img {
    display:none;
  }
}
</style>
<style scoped>
  .headWhite {
      background-color: white !important;
    }
</style>
